import { Meta } from "../partials/meta";

export default function Services() {
    return (
        <>
            <Meta title="Services" description="A List of Services"/>
            <h1>This is what we do...</h1>
        </>
    );
}